<script lang="ts">
	import {
		CircleWithWarning,
		CircleWithAdd,
		AdaptiveTextInput,
		XIcon,
	} from "@hitit/new_ui/src";
	import { createEventDispatcher } from "svelte";
	import { t } from "@hitit/hub/src/stores";

	//Props
	export let editmode = false;
	export let hashtags: string[];

	let addButtonHover = false;

	const hashTagMaxLength = 10;
	const dispatch = createEventDispatcher();

	$: btnFill = addButtonHover ? "#6591fa" : "#6d6f76";
	$: if (hashtags.length === 10) {
		addButtonHover = false;
	}
	function deleteHashtag(index: number) {
		dispatch("DELETE_HASH_TAG", {
			index,
		});
	}

	function addHashTag() {
		if (hashtags.length === hashTagMaxLength) return;
		dispatch("ADD_HASH_TAG");
	}

</script>

<div class="container">
	{#if editmode}
		<div class="hashtag-input-wrapper">
			{#each hashtags as hashtag, index}
				<div class="hashtag-input">
					<AdaptiveTextInput
						bind:value={hashtag}
						clearButtonForceDisplay
						backgroundColor={'transparent'}
						placeholder={$t('hub.place.Hashtag_length')}
						noFocusoutline
						length={10}>
						<div slot="left-icon">
							{#if hashtag !== ''}<span class="shop">#</span>{/if}
						</div>
						<div
							class="x-icon"
							slot="clear"
							on:click={() => deleteHashtag(index)}>
							<XIcon />
						</div>
					</AdaptiveTextInput>
				</div>
			{:else}<span class="desc">{$t('hub.place.Add_hashtags')}</span>{/each}
			{#if hashtags.length < 10}
				<span
					class="add-button"
					on:click={addHashTag}
					on:mouseenter={() => (addButtonHover = true)}
					on:mouseleave={() => (addButtonHover = false)}>
					<CircleWithAdd fill={btnFill} />
				</span>
			{/if}
		</div>
	{:else}
		<div class="hashtag-wrpper">
			{#each hashtags as hashtag}
				<span class="hashtag">#{hashtag}</span>
			{:else}
				<div class="no-hashtags">
					<span class="icon">
						<CircleWithWarning />
					</span>
					<span class="desc">{$t('hub.place.No_hashtags')}</span>
				</div>
			{/each}
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		margin-top: 20px;
		box-sizing: border-box;
		width: 100%;
		padding: 10px;
		display: flex;
		justify-content: center;

		.hashtag-input-wrapper {
			display: flex;
			flex-direction: column;
			gap: 6px;
			width: 100%;
			align-items: center;
			justify-content: center;

			.hashtag-input {
				width: 100%;
				height: 25px;
				background-color: #f0f0f4;
				border-radius: 12.5px;
				font-size: 14px;
				color: #46474b;
				font-weight: 200;
				.x-icon {
					display: flex;
					min-width: 16px;
					min-height: 16px;
					width: 16px;
					height: 16px;

					&:hover {
						cursor: pointer;
					}
				}

				.shop {
					color: #46474b;
					font-size: 1rem;
					margin-right: 2px;
				}
			}

			.desc {
				text-align: center;
				font-size: 0.875rem;
				color: #6d6f76;
			}

			.add-button {
				margin-top: 4px;
				width: 30px;
				height: 30px;

				&:hover {
					cursor: pointer;
				}
			}
		}

		.hashtag-wrpper {
			width: 100%;
			display: flex;
			justify-content: center;
			flex-wrap: wrap;
			gap: 15px;
			.hashtag {
				color: #6d6f76;
				font-size: 0.875rem;
			}

			.no-hashtags {
				display: flex;
				align-items: center;
				gap: 10px;
				.icon {
					width: 24px;
					height: 24px;
				}
				.desc {
					color: #6d6f76;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			margin-top: 30px;

			.hashtag-input-wrapper {
				max-width: 1260px;
				flex-direction: row;
				flex-wrap: wrap;
				gap: 20px;
				.hashtag-input {
					box-sizing: border-box;
					width: 236px;
					height: 40px;
					padding: 3px 5px;
					border-radius: 20px;
					font-size: 1.25rem;
					.x-icon {
						min-width: 17px;
						min-height: 17px;
						width: 17px;
						height: 17px;

						&:hover {
							cursor: pointer;
						}
					}
					.shop {
						margin-right: 4px;
						font-size: 1.25rem;
					}
				}

				.desc {
					font-size: 1.25rem;
				}
				.add-button {
					margin-top: 0px;
					width: 40px;
					height: 40px;
				}
			}

			.hashtag-wrpper {
				.hashtag {
					font-size: 1.25rem;
				}
				.no-hashtags {
					align-items: auto;
					.desc {
						font-size: 1.25rem;
					}
				}
			}
		}
	}

</style>
